/* eslint-disable default-param-last */
const INITIAL_STATE = {
  singlePhaseCurrentStats: [],
  activePowerStats: [],
  apparentPowerStats: [],
  reactivePowerStats: [],
  powerFactorStats: [],
  phaseAngleStats: [],
  frequencyStats: [],
  importActiveEnergyStats: [],
  exportActiveEnergyStats: [],
  importReactiveEnergyStats: [],
  exportReactiveEnergyStats: [],
  totalActiveEnergyStats: [],
  totalReactiveEnergyStats: [],
};

const dashboardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_SINGLE_PHASE_CURRENT_STATS":
      state.singlePhaseCurrentStats = action.payload;
      return {
        ...state,
      };
    case "SET_ACTIVE_POWER_STATS":
      state.activePowerStats = action.payload;
      return {
        ...state,
      };
    case "SET_APPARENT_POWER_STATS":
      state.apparentPowerStats = action.payload;
      return {
        ...state,
      };
    case "SET_REACTIVE_POWER_STATS":
      state.reactivePowerStats = action.payload;
      return {
        ...state,
      };
    case "SET_POWER_FACTOR_STATS":
      state.powerFactorStats = action.payload;
      return {
        ...state,
      };
    case "SET_PHASE_ANGLE_STATS":
      state.phaseAngleStats = action.payload;
      return {
        ...state,
      };
    case "SET_FREQUENCY_STATS":
      state.frequencyStats = action.payload;
      return {
        ...state,
      };
    case "SET_IMPORT_ACTIVE_ENERGY_STATS":
      state.importActiveEnergyStats = action.payload;
      return {
        ...state,
      };
    case "SET_EXPORT_ACTIVE_ENERGY_STATS":
      state.exportActiveEnergyStats = action.payload;
      return {
        ...state,
      };
    case "SET_IMPORT_REACTIVE_ENERGY_STATS":
      state.importReactiveEnergyStats = action.payload;
      return {
        ...state,
      };
    case "SET_EXPORT_REACTIVE_ENERGY_STATS":
      state.exportReactiveEnergyStats = action.payload;
      return {
        ...state,
      };
    // case "SET_IMPORT_ACTIVE_ENERGY_STATS":
    //   state.importActiveEnergyStats = action.payload;
    //   return {
    //     ...state,
    //   };
    // case "SET_EXPORT_ACTIVE_ENERGY_STATS":
    //   state.exportActiveEnergyStats = action.payload;
    //   return {
    //     ...state,
    //   };
    case "SET_TOTAL_ACTIVE_ENERGY_STATS":
      state.totalActiveEnergyStats = action.payload;
      return {
        ...state,
      };
    case "SET_TOTAL_REACTIVE_ENERGY_STATS":
      state.totalReactiveEnergyStats = action.payload;
      return {
        ...state,
      };
    default:
      return state;
  }
};
export default dashboardReducer;
